module.exports = __webpack_public_path__ + "static/media/amsterdam.052e35e5.jpg";